import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import {
  AutomaticPaymentRemindersModalFormContextProvider,
  AutomaticPaymentRemindersType,
  type PaymentRemindersDetails,
} from '@features/invoicingSettings/modules/paymentsAndReminders'

import { AutomaticPaymentRemindersModalComponent } from './elements/AutomaticPaymentRemindersModalComponent'

interface AutomaticPaymentRemindersModalProps extends ModalProps {
  defaultValues: PaymentRemindersDetails
  onSubmit: (paymentReminderDetails: PaymentRemindersDetails) => void
  variant: AutomaticPaymentRemindersType
}

const AutomaticPaymentRemindersComponent = ({
  defaultValues,
  onSubmit,
  variant,
  ...modalProps
}: AutomaticPaymentRemindersModalProps): ReactElement => {
  return (
    <Modal {...modalProps} size="s">
      <AutomaticPaymentRemindersModalFormContextProvider
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        variant={variant}
      >
        <AutomaticPaymentRemindersModalComponent modalId={modalProps.id} />
      </AutomaticPaymentRemindersModalFormContextProvider>
    </Modal>
  )
}

export const AutomaticPaymentRemindersModal = withModalConditionalRender(AutomaticPaymentRemindersComponent)
